const USER_EMAIL_KEY = 'sim_user_email';

// Email del usuario, persistido por navegador. Se solicita una vez al iniciar
// la práctica y se reutiliza en futuras sesiones (autocompletado de la encuesta
// final, correlación de thread_ids con un mismo usuario en backend).
export function getUserEmail() {
    try {
        return window.localStorage.getItem(USER_EMAIL_KEY) || '';
    } catch (_) {
        return '';
    }
}

export function setUserEmail(email) {
    try {
        const trimmed = (email || '').trim();
        if (trimmed) window.localStorage.setItem(USER_EMAIL_KEY, trimmed);
    } catch (_) {}
}

export function clearUserEmail() {
    try {
        window.localStorage.removeItem(USER_EMAIL_KEY);
    } catch (_) {}
}

export function hasUserEmail() {
    return !!getUserEmail();
}
